// @flow
import * as React from 'react';

import { INDEX } from '@routes';
import { Link } from '@i18n';

import { StyledLogo, StyledLogoWrapper, StyledHeroLogo } from './styles';

const HomeLinkLogo = ({ heroSection }: {
  heroSection?: boolean
}) => (
  <Link href={INDEX} passHref>
    <StyledLogoWrapper>
      {heroSection
        ? <StyledHeroLogo alt="Yapita Health Logo" />
        : <StyledLogo alt="Yapita Health Logo" />}
    </StyledLogoWrapper>
  </Link>
);

export default HomeLinkLogo;
